const emailRegex = /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
const phoneNumberRegex = /^$|^\+?1? ? ?[( .-]?[0-9]{3}[) .-]? ?[0-9]{3}[ .-]?[0-9]{4}$/;

export const requiredValidator = {
  isRequiredTrim: {
    value: true,
  },
};

export const requiredValidatorShortMessage = {
  isRequiredTrim: {
    value: true,
    customMessageKey: "validation.isRequiredTrimShort",
  },
};

export const optionalEmailValidator = {
  regex: {
    value: {
      pattern: emailRegex,
      customMessageKey: "validation.customMessages.emailAddressRegex",
    },
  },
};

export const optionalPhoneNumberValidator = {
  regex: {
    value: {
      pattern: phoneNumberRegex,
    },
  },
};

export const requiredEmailValidator = {
  ...optionalEmailValidator,
  ...requiredValidator,
};

export const applyMaxLength = (n = 128) => ({
  maxLength: {
    value: n,
  },
});



// WEBPACK FOOTER //
// ./src/utils/validators.js